import { api } from './client'
import { ProfileTypes } from '../../typings'

export const retrievePreEmptiveRights = (profileType: ProfileTypes, assetId: string): Promise<any> => {
    return api.get(`v2/secondary-market/get-pre-emptive-rights/${profileType}/${assetId}`)
}

export const fetchBalance = (id: string): Promise<any> => {
    return api.get(`v2/secondary-market/order-book/balance/${id}`)
}
